import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import useTypedContext from "hooks/useTypedContext";
import { ModuleSettingsContext } from "views/Account/ModuleSettings/Context";

import { WebhookIntegrationWithTimestamp } from "../types";

const ModuleWebhooksTableEndpointCell = ({
  item: webhook,
  ...cellProps
}: TableSimpleCellProps<WebhookIntegrationWithTimestamp>) => {
  const { module } = useTypedContext(ModuleSettingsContext);

  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellLink href={`/module/${module.id}/settings/integrations/webhook/${webhook.id}`}>
        {webhook.endpoint}
      </TableCellLink>
    </TableSimpleCell>
  );
};

export default ModuleWebhooksTableEndpointCell;
